import React, { useState, useEffect  } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'
import * as UserActions from '../../../actions/UserActions'
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import { loginWithToken } from '../../../utils/Helper'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { API_URL } from '../../../utils/Settings'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from 'reactstrap';
import PaymentSubHeader from '../parts/PaymentSubHeader'
import SubscribeCheckoutForm from '../parts/SubscribeCheckoutForm'
import * as AbstructedApi from '../../../utils/AbstructedApi'

let clientSecret = ""

// PaymentAdd
const PaymentAdd = (props) => {

  // use history
  let navigate = useNavigate()

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  });

  let dispatch = useDispatch();

  // parameters
  let [loading, setLoading] = useState(false);
  let [defaultCard, setDefaultCard] = useState(null)

  // componentDidMount
  useEffect(() => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // first script
  let _firstScript = async () => {

    let _obj = await AbstructedApi.checkSubscriptionStatus(login_token)

    // set default card info
    setDefaultCard(_obj.card_info)
  }

  /// stripe

  // payment success
  let _paymentSuccess = () => {
    dispatch(UserActions.setSubscriptionStatus({
      subscription_status: "active",
    }))
  }

  // payment failed
  let _errorRecieved = () => {

  }

  return (
    <div style={{
      backgroundColor: '#F2F5FA',
    }}>

      {/* header */}
      <Header />

      {/* sub header */}
      <PaymentSubHeader />

      <Container>

        <Row>
          <Col md="3" xs="12" />

          <Col md="6" xs="12">

            {/* stripe */}
            <SubscribeCheckoutForm
              defaultCard={defaultCard}
              login_token={login_token}
              paymentSuccess={_paymentSuccess}
              clientSecret={clientSecret}
              setLoading={setLoading}
              errorRecieved={_errorRecieved} />


          </Col>
          <Col md="3" xs="12" />
        </Row>

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default PaymentAdd
